var _path, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInterfaceErrorTriangleSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outline_art_-_SVG_EXPORT",
    "data-name": "outline art - SVG EXPORT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.03,30.66H6c-.72,0-1.39-.37-1.73-.97-.32-.56-.32-1.23,0-1.79L16.35,6.21c.36-.54.99-.87,1.67-.87h0c.68,0,1.3.33,1.67.87l12.08,21.71c.32.54.32,1.21,0,1.77-.34.6-1.01.97-1.73.97Zm0-1.76s0,0,0,0h0Zm-24.01-.01h0s0,0,0,0ZM18.01,7.32L6.11,28.73l23.79-.07L18.01,7.32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.02,
    cy: 25.09,
    r: 1.66
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.63,
    y: 14.11,
    width: 2.78,
    height: 7.77
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInterfaceErrorTriangleSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-interface-error-triangle-small.a56ff4f69b5ec3af8fe3862003e29179.svg";